import React from 'react';
import { AbstractTask } from 'nekst-api';
import {
  Button,
  ButtonColor,
  ButtonSize,
  ButtonVariant,
  isReactNative,
  Right,
  SimpleBlock,
  useFormContextRequired,
  usePopupManager,
} from 'ui-builder';
import { RoadmapPreview } from './RoadmapPreview';
import { ClosePopupButton, Popup } from 'features/nekst-widgets';

interface PreviewPopupProps {
  task: AbstractTask & { copyRoadmapDescription?: boolean };
}

function PreviewPopup(props: PreviewPopupProps) {
  const { task } = props;

  return (
    <Popup
      title="Preview Roadmap Description"
      content={
        <RoadmapPreview
          projectId={task.projectId}
          taskName={task.name || ''}
          roadmapDescription={task.roadmapDescription}
          taskDescription={task.description}
        />
      }
      isBig={isReactNative()}
      buttons={
        <ClosePopupButton
          text="Close"
          color={ButtonColor.GRAY}
          size={ButtonSize.MEDIUM}
        />
      }
    />
  );
}

export function PreviewRoadmapButton() {
  const popupManager = usePopupManager();
  const formContext = useFormContextRequired<
    AbstractTask & { copyRoadmapDescription?: boolean }
  >();

  const data = formContext.data;

  if (!data?.isIncludedToRoadmap || !data?.projectId) {
    return null;
  }

  const openPreview = async () => {
    popupManager.openPopup(<PreviewPopup task={data} />, true);
  };

  return (
    <SimpleBlock>
      <Right>
        <Button
          onClick={openPreview}
          text="Preview"
          size={ButtonSize.SMALL}
          color={ButtonColor.BLUE}
          variant={ButtonVariant.FILLED}
          isDisabled={!data.roadmapDescription}
        />
      </Right>
    </SimpleBlock>
  );
}
